import React, { useEffect, useState } from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Badge, AsyncSection } from "../ds";
import { useTableStyles } from "../tableStyles";
import { qualityFleet } from "./api";
import { fmtRate } from "./shared";

export default function QualityTab({ range, refreshKey, onOpenAgent }) {
  const table = useTableStyles();
  const [state, setState] = useState({ loading: true, notFound: false, error: null, data: null });

  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    qualityFleet({ from: range.from, to: range.to }).then((r) => alive && setState({ ...r, loading: false }));
    return () => {
      alive = false;
    };
  }, [range.from, range.to, refreshKey]);

  const agents = state.data?.agents || [];
  const backlog = state.data?.backlog?.judge_failed || 0;

  return (
    <Box>
      {backlog > 0 && (
        <Alert severity="error" style={{ margin: 16 }} data-testid="judge-backlog">
          {backlog} episode{backlog === 1 ? "" : "s"} could not be judged (judge_failed) — check judge credits and the quality queue DLQ.
        </Alert>
      )}
      <AsyncSection
        loading={state.loading}
        notFound={state.notFound}
        error={state.error}
        empty={!state.notFound && !state.error && !agents.length}
        emptyTitle="No judged episodes in range"
      >
        <div className={table.tableWrap}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {["Agent", "Episodes", "Judged", "Goal rate by motion", "Critical-bad", "Handoff (ok / extra / missed)"].map((h, i) => (
                  <TableCell key={h} className={`${table.headCell} ${i === 1 || i === 2 || i === 4 ? table.num : ""}`}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {agents.map((a) => {
                const motions = Object.entries(a.goal_rate_by_motion || {});
                const h = a.handoff || {};
                return (
                  <TableRow key={`${a.project_id}:${a.agent_id}`} className={table.clickRow} onClick={() => onOpenAgent && onOpenAgent(a)}>
                    <TableCell className={table.cell}>
                      <Typography component="div" className={table.nameText}>{a.project_id}</Typography>
                      <div className={table.monoSub}>{a.agent_id || "—"}</div>
                    </TableCell>
                    <TableCell className={`${table.cell} ${table.num}`}>{a.episodes}</TableCell>
                    <TableCell className={`${table.cell} ${table.num}`}>
                      {a.judged}
                      {a.failed_judge > 0 && <Badge tone="error" subtle style={{ marginLeft: 6 }}>{a.failed_judge} failed</Badge>}
                    </TableCell>
                    <TableCell className={table.cell}>
                      <Box display="flex" flexWrap="wrap" gridGap={6}>
                        {motions.length ? motions.map(([m, r]) => (
                          <Badge key={m} tone={r == null ? "neutral" : r >= 0.7 ? "success" : r >= 0.4 ? "warning" : "error"} subtle>
                            {m} {fmtRate(r)}
                          </Badge>
                        )) : "—"}
                      </Box>
                    </TableCell>
                    <TableCell className={`${table.cell} ${table.num}`} style={{ color: a.critical_bad_rate > 0 ? "#F44336" : undefined }}>
                      {fmtRate(a.critical_bad_rate)}
                    </TableCell>
                    <TableCell className={table.cell}>{h.correct || 0} / {h.unnecessary || 0} / {h.missed || 0}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </AsyncSection>
    </Box>
  );
}
